// overview-derived business rules (holds / overdue / departing / pending AnF / delivered)
// ported from renderer.js:133-136, 1786-1811. pure functions so screens don't embed logic
/** parse an assembly-completion value ('85', '0.85', '85%', EL '85,5') to a 0–100 number.
 *  A value tagged with '%' is already a percentage and is taken as-is ('1%' → 1, not 100).
 *  Only a bare fraction (no '%', ≤ 1 — e.g. Smartsheet's raw 0.85) is rescaled to 0–100. */
export function assemblyPctNum(v) {
    const raw = String(v.assemblyPct ?? '').trim();
    const hadPercent = raw.includes('%');
    const s = raw.replace('%', '').replace(',', '.').trim();
    const n = parseFloat(s);
    if (isNaN(n))
        return 0;
    return !hadPercent && n <= 1 ? n * 100 : n;
}
const HOLD_FIELDS = [
    'engineInstall',
    'engineStartup',
    'seaTrial',
    'pdi',
    'uh',
    'stickers',
    'wa',
    'pol',
];
export function isOverviewHold(v) {
    return HOLD_FIELDS.some((f) => v[f] === 'Hold');
}
export function isDelivered(v) {
    return v.left || v.deliveryConfirmed || assemblyPctNum(v) >= 100;
}
export function parseDeliveryDate(v) {
    const m = String(v.deliveryDate || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])) : null;
}
export function isOverdue(v, now) {
    if (isDelivered(v))
        return false;
    const d = parseDeliveryDate(v);
    return d ? d < now : false;
}
export function isDeparting(v, now, days = 14) {
    if (v.left)
        return false;
    const d = parseDeliveryDate(v);
    if (!d)
        return false;
    const end = new Date(now);
    end.setUTCDate(end.getUTCDate() + days);
    return d >= now && d <= end;
}
export function isPendingAnf(v) {
    return !v.left && v.anf === 'Hold' && assemblyPctNum(v) > 79;
}
//# sourceMappingURL=overview.js.map